import { defineStore } from 'pinia';
import { ref } from 'vue';
import leadsAPI from '@/api/leads';
import type { Lead } from '@/types/Lead';

export const useLeadsStore = defineStore('leads', () => {
  const leads = ref<Lead[]>([]);
  
  const fetchLeads = async (params: any): Promise<{ data: Lead[]; total: number }> => {
    try {
      
      const response = await leadsAPI.getLeads(params);
      const data: Lead[] = response.data.data;
      const total = response.data.meta.total;
      leads.value = data;
      return { data, total };
    } catch (error) {
      console.error('Error fetching lead s:', error);
      throw error;
    }
  };

  const fetchLeadById = async (id: number) => {
    try {
      const response = await leadsAPI.getLeadById(id);
      return response.data as Lead;
    } catch (error) {
      console.error(`Error fetching lead  with ID ${id}:`, error);
      throw error;
    }
  };

  const createLead = async (leadData: Partial<Lead>) => {
    try {
      const response = await leadsAPI.createLead(leadData);
      if (!response.data.success) {
        throw response.data;
      }
      leads.value.push(response.data.data as Lead);
      return response.data;
    } catch (error) {
      console.error('Error creating lead :', error);
      throw error;
    }
  };

  const updateLead = async (id: number, leadData: Partial<Lead>) => {
    try {
      const response = await leadsAPI.updateLead(id, leadData);
      if (!response.data.success) {
        throw response.data;
      }
      const updated = response.data.data as Lead;
      const index = leads.value.findIndex((l:any) => l.id === id);
      if (index !== -1) {
        leads.value[index] = updated;
      }
      return response.data;
    } catch (error) {
      console.error(`Error updating lead  with ID ${id}:`, error);
      throw error;
    }
  };

  const deleteLead = async (id: number) => {
    try {
      await leadsAPI.deleteLead(id);
      leads.value = leads.value.filter((l:any) => l.id !== id);
    } catch (error) {
      console.error(`Error deleting lead  with ID ${id}:`, error);
      throw error;
    }
  };

  const exportCSV = async (params: string, body: any) => {
    try {
      return await leadsAPI.exportCSV(params, body);
    } catch (error) {
      console.error('Error exportando archivo:', error);
      throw error;
    }
  };

  return {
    leads,
    fetchLeads,
    fetchLeadById,
    createLead,
    updateLead,
    deleteLead,
    exportCSV
  };
});
